import { ListboxOptionMedia } from './ListboxOptionMedia';

// TODO: in v9, move styled() from ListboxOptionMedia.jsx to here
export var StyledListboxOptionMedia = ListboxOptionMedia;